/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type ErrorCode = (typeof ErrorCode)[keyof typeof ErrorCode];

export const ErrorCode = {
  VALIDATION: "VALIDATION",
  INVALID_PHONE_NUMBER: "INVALID_PHONE_NUMBER",
  EMAIL_DOMAIN_NOT_ALLOWED: "EMAIL_DOMAIN_NOT_ALLOWED",
  UNAUTHORIZED: "UNAUTHORIZED",
  FORBIDDEN: "FORBIDDEN",
  FORBIDDEN_FEATURE: "FORBIDDEN_FEATURE",
  IMPERSONATION_DENIED: "IMPERSONATION_DENIED",
  NOT_FOUND: "NOT_FOUND",
  CONFLICT: "CONFLICT",
  PHONE_NUMBER_IN_USE: "PHONE_NUMBER_IN_USE",
  LOCKED: "LOCKED",
  FAILED_DEPENDENCY: "FAILED_DEPENDENCY",
  TOO_MANY_REQUESTS: "TOO_MANY_REQUESTS",
  UPSTREAM_UNAVAILABLE: "UPSTREAM_UNAVAILABLE",
  INTERNAL: "INTERNAL",
} as const;
